import i18n from "i18n";
export const PASSWORD_SPECIAL_CHARACTERS = "!@#$%^&*()-_=+[]{}|;:,.<>?/";
export const DEFAULT_PASSWORD_COMPLEXITY_CONFIG = {
  min_length: 6,
  require_uppercase: false,
  require_lowercase: false,
  require_numbers: false,
  require_special_chars: false
};
const containsSpecialCharacter = (password) => Array.from(PASSWORD_SPECIAL_CHARACTERS).some((character) => password.includes(character));
const passwordComplexityRuleMessages = (config) => ({
  min_length: i18n.t("password_rules.min_length", { ns: "users", minLength: config.min_length }),
  require_uppercase: i18n.t("password_rules.require_uppercase", { ns: "users" }),
  require_lowercase: i18n.t("password_rules.require_lowercase", { ns: "users" }),
  require_numbers: i18n.t("password_rules.require_numbers", { ns: "users" }),
  require_special_chars: i18n.t("password_rules.require_special_chars", {
    ns: "users",
    characters: PASSWORD_SPECIAL_CHARACTERS
  })
});
export const passwordComplexityHelpLines = (config) => {
  const messages = passwordComplexityRuleMessages(config);
  const requirements = [messages.min_length];
  if (config.require_uppercase) requirements.push(messages.require_uppercase);
  if (config.require_lowercase) requirements.push(messages.require_lowercase);
  if (config.require_numbers) requirements.push(messages.require_numbers);
  if (config.require_special_chars) requirements.push(messages.require_special_chars);
  return requirements;
};
export const passwordComplexityErrors = (password, config = DEFAULT_PASSWORD_COMPLEXITY_CONFIG) => {
  if (!password) {
    return [];
  }
  const errors = [];
  const messages = passwordComplexityRuleMessages(config);
  if (password.length < config.min_length) {
    errors.push(messages.min_length);
  }
  if (config.require_uppercase && !/[A-Z]/.test(password)) {
    errors.push(messages.require_uppercase);
  }
  if (config.require_lowercase && !/[a-z]/.test(password)) {
    errors.push(messages.require_lowercase);
  }
  if (config.require_numbers && !/\d/.test(password)) {
    errors.push(messages.require_numbers);
  }
  if (config.require_special_chars && !containsSpecialCharacter(password)) {
    errors.push(messages.require_special_chars);
  }
  return errors;
};
